export const RBAC_ROLE_DETAIL_TAB_VALUE = 'detail'
export const RBAC_ROLE_PERMISSIONS_TAB_VALUE = 'permissions'
export const RBAC_ROLE_USERS_TAB_VALUE = 'users'
export const RBAC_ROLE_HISTORY_TAB_VALUE = 'history'

export const RBAC_ROLE_DETAIL_TEXTS = {
  loading: 'Cargando...',
  notFound: 'Rol no encontrado.',
  backToRolesLabel: 'Volver a roles y permisos',
  detailTitle: 'Detalles del rol',
  permissionsTitle: 'Permisos del rol',
  usersTitle: 'Listado de usuarios',
  historyTitle: 'Historial del rol',
  historySubtitle: 'Detalles del historial del rol',
  summaryTitle: 'INFORMACIÓN DEL ROL',
  deactivateModalTitle: '¿Inactivar este rol?',
  deactivateModalBody:
    'El rol pasará a estado inactivo y no estará disponible para nuevas asignaciones hasta que lo reactives.',
  activateModalTitle: '¿Activar este rol?',
  activateModalBody:
    'El rol volverá a estar activo y disponible para asignarse a usuarios.',
  cannotInactivateModalTitle: 'No es posible inactivar este rol',
  cannotInactivateModalConfirm: 'Ir a reasignar usuarios',
  cancel: 'Cancelar',
  editRole: 'Editar rol',
  activateRole: 'Activar rol',
  inactivateRole: 'Inactivar rol'
}
